// extracted by mini-css-extract-plugin
export default {"paragraph":"Paragraph_paragraph__BDG8L","paragraph1":"Paragraph_paragraph1__ktS3L","paragraph2":"Paragraph_paragraph2__9EodJ","paragraph3":"Paragraph_paragraph3__6PF+v"};